import { messaging } from '../store/sagas/firebase';

export default () => !!messaging && !!Notification && Notification.permission;
